import { SVGProps } from 'react';

const SvgPackage = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M10.502 1.403a3 3 0 0 1 2.996 0l.002.001 7 4a3 3 0 0 1 .937.848 1 1 0 0 1 .249.414A3 3 0 0 1 22 7.999v8.002a3 3 0 0 1-1.5 2.595l-.004.002-6.996 3.998-.002.001a3 3 0 0 1-2.996 0H10.5l-6.996-3.999-.004-.002A3 3 0 0 1 2 16.001V8a3 3 0 0 1 .314-1.333 1.004 1.004 0 0 1 .25-.414 3 3 0 0 1 .936-.848l.004-.002 3.249-1.857a1 1 0 0 1 .553-.316l3.196-1.826ZM7.55 5.393 5.039 6.828 12 10.855l2.507-1.45L7.55 5.393Zm8.955 2.856L9.561 4.244l1.935-1.106.004-.002a1 1 0 0 1 1 0l6.461 3.692-2.456 1.42ZM20 8.538l-7.5 4.338a1 1 0 0 1-1 0L4 8.538v7.461a1 1 0 0 0 .498.864l.002.001 7 4a1 1 0 0 0 1 0l.004-.002 6.996-3.998h.002a1.001 1.001 0 0 0 .498-.865V8.538Z"
      clipRule="evenodd"
    />
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M12 11a1 1 0 0 1 1 1v10.08a1 1 0 1 1-2 0V12a1 1 0 0 1 1-1Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgPackage;
